import React, { useContext, useState, useEffect } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Button,
  Box,
  Text,
} from "@chakra-ui/react";
import { UsersContext } from "../../../Context/UsersContext";
import ClientItem from "./ClientItem";
import ConfirmationSwal from "../../../../Utils/confirmationSwal";

function ClientsTable({ newClients, setNewClients, setIsEdited }) {
  const { users, getUsers } = useContext(UsersContext);
  const [showNewClient, setShowNewClient] = useState(false);

  useEffect(() => {
    getUsers({ roleId: 4 });
  }, []);

  const addClient = (client) => {
    let updatedClients = [...newClients];
    setNewClients([...updatedClients, client]);
  };

  const removeClient = (client) => {
    ConfirmationSwal.fire({
      title: "Quitar vendedor",
      text: "¿Está seguro que desea desvincular al cliente del vendedor?",
      icon: "question",
      confirmButtonText: "Si",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const updatedClients = newClients.filter(
          (item) => item.id !== client.id
        );
        setNewClients(updatedClients);
      }
    });
  };

  return (
    <>
      <Text p="1rem" fontSize="1.2em" fontWeight="bold" color="gray.800">
        Clientes
      </Text>
      <Button
        colorScheme="blue"
        onClick={() => setShowNewClient(true)}
        isDisabled={showNewClient}
        m={"1rem"}
      >
        + Cliente
      </Button>
      <Box overflowX={"scroll"} pb={"0.5rem"}>
        <Table variant="striped" colorScheme="gray" fontSize="0.8em" w="100%">
          <Thead>
            <Tr>
              {/*     <Th fontSize="0.8em"></Th> */}
              <Th fontSize="0.8em">Razon Social</Th>
              <Th fontSize="0.8em" w="25%">
                Domicilio
              </Th>
              <Th fontSize="0.8em">Email</Th>
              <Th fontSize="0.8em">Zona</Th>
              <Th fontSize="0.8em">Lista de precio</Th>
              <Th fontSize="0.8em" textAlign="center">
                Acciones
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {showNewClient && (
              <ClientItem
                client={{}}
                setShowNewClient={setShowNewClient}
                addClient={addClient}
                initialAction={"new"}
                clientsList={users}
                newClientsList={newClients}
                setIsEdited={setIsEdited}
              />
            )}
            {newClients.map((client) => (
              <ClientItem
                key={client.id}
                newClientsList={newClients}
                client={client}
                clientList={users}
                deleteClientHandler={removeClient}
                setIsEdited={setIsEdited}
              ></ClientItem>
            ))}
          </Tbody>
        </Table>
      </Box>
    </>
  );
}

export default ClientsTable;
